<template>
  <div>
    <h3>Findmykit Partner Organisation Terms and Conditions</h3>

    <ol class="terms">
      <li class="outer">
        <h3>Terms</h3>
        <ol>
          <li>These Terms will apply to any contract between us for the findmykit partner organisation lost property service (Contract).</li>
          <li>Please read these Terms carefully and make sure that you understand them, before commencing as a partner organisation.</li>
          <li>Please note by agreeing to these terms you are agreeing to become a partner organisation in the findmykit lost property service and you agree to be bound by these Terms and the other documents expressly referred to in it.</li>
          <li>If you refuse to accept these Terms, you will not be able to become a partner organisation.</li>
          <li>You should print a copy of these Terms for future reference.</li>
          <li>We may amend these Terms from time to time.</li>
          <li>We will notify you of each amendment and ask you to understand and agree to the amendment (s).</li>
          <li>These Terms, and any Contract between us, are only in the English language.</li>
        </ol>
      </li>

      <li class="outer">
        <h3>Information about us</h3>
        <ol>
          <li>We operate the findmykit lost property service. We are Find My Kit Limited, a company registered in England and Wales under company number 08083443 and with our registered office at 2A Bank Street Tonbridge TN9 1BL.</li>
          <li>To contact us, please e-mail <a href="mailto:support@findmykit.com">support@findmykit.com</a></li>
        </ol>
      </li>

      <li class="outer">
        <h3>How the contract is formed between you and us</h3>
        <ol>
          <li>You agree to joining the findmykit as a partner organisation signing up as an organisation on our website.</li>
          <li>After you sign up as an organisation you will receive an e-mail from us acknowledging the sign up and you will be asked via a separate email to verify your email address. </li>
          <li>Once you have verified your email address you will be directed to your organisation dashboard - My Organisation which will allow you to operate the findmykit lost property service for your organisation.</li>
          <li>This forms the contract between findmykit and your organisation.</li>
        </ol>
      </li>

      <li class="outer">
        <h3>Our right to vary these terms</h3>
        <ol>
          <li>We may revise these Terms from time to time in the following circumstances:
            <ol>
              <li>Changes in how we operate the findmykit lost property service.</li>
              <li>Changes in relevant laws and regulatory requirements.</li>
            </ol>
          </li>
        </ol>
      </li>

      <li class="outer">
        <h3>Termination</h3>
        <ol>
          <li>If you would like to terminate your contract you can do so by giving findmykit 30 days notice in writing to <a href="mailto:support@findmykit.com">support@findmykit.com</a></li>
          <li>We require you to email all the partner members of your organisation to advise them that you will no longer be providing the lost property service for them </li>
          <li>We may offer them an alternative product </li>
          <li>At the end of the 30 day notice period we will deactivate your partner organisation account on our system </li>
          <li>You must return all materials that belong to findmykit and provided to you as part of this contract to Findmykit Ltd, 2A Bank Street Tonbridge TN9 1BL</li>
        </ol>
      </li>

      <li class="outer">
        <h3>Liability</h3>
        <ol>
          <li>You acknowledge that we give no warranty or guarantee for the return or collection of any items returned to you or discovered even where a personalised name tag has been attached to the same. Clearly the return of any item to you will be dependent upon a number of factors aside from the existence of a tag including the relevant item being found, contact being made with you by the finder of the item and/or tag not having been damaged or interfered with.</li>
          <li>Subject to clause 57, we will under no circumstances whatever be liable to you, whether in contract, tort (including negligence), breach of statutory duty or otherwise, arising under or in connection with the contract for:
            <ol>
              <li>any indirect or consequential loss; or</li>
              <li>any loss of profits; or</li>
              <li>any loss of any item </li>
            </ol>
          </li>
          <li>We only supply the Products for domestic and private use. You agree not to use any returned items for any commercial, business or re-sale purposes, and we have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.</li>
          <li>We do not in any way exclude or limit our liability for:
            <ol>
              <li>death or personal injury caused by our negligence;</li>
              <li>fraud or fraudulent misrepresentation;</li>
              <li>any breach of the terms implied by section 12 of the Sale of Goods Act 1979 (title an quiet possession);</li>
              <li>any breach of the terms implied by section 13 to 15 of the Sale of Goods Act 1979 (description, satisfactory quality, fitness for purpose and samples); and
                defective products under the Consumer Protection Act 1987.
              </li>
            </ol>
          </li>
        </ol>
      </li>

      <li class="outer">
        <h3>Events outside our control</h3>
        <ol>
          <li>We will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations under a Contract that is caused by an Event Outside Our Control. An Event Outside Our Control is defined below in clause 7.2.</li>
          <li>An Event Outside Our Control means any act or event beyond our reasonable control, including without limitation strikes, lock-outs or other industrial action by third parties, civil commotion, riot, invasion, terrorist attack or threat of terrorist attack, war (whether declared or not) or threat or preparation for war, fire, explosion, storm, flood, earthquake, subsidence, epidemic or other natural disaster, or failure of public or private telecommunications networks or impossibility of the use of railways, shipping, aircraft, motor transport or other means of public or private transport.</li>
          <li>If an Event Outside Our Control takes place that affects the performance of our obligations under a Contract:
            <ol>
              <li>we will contact you as soon as reasonably possible to notify you; and</li>
              <li>our obligations under a Contract will be suspended and the time for performance of our obligations will be extended for the duration of the Event Outside Our Control. Where the Event Outside Our Control affects our delivery of Products to you, we will arrange a new delivery date with you after the Event Outside Our Control is over.</li>
            </ol>
          </li>
        </ol>
      </li>

      <li class="outer">
        <h3>Communications between us</h3>
        <ol>
          <li>When we refer, in these Terms, to "in writing", this will include e-mail.</li>
          <li>If you wish to contact us in writing, or if any clause in these Terms requires you to give us notice in writing, you can send this to us by e-mail <a href="mailto:support@findmykit.com">support@findmykit.com</a> or by pre-paid post to Findmykit Ltd, 2A Bank Street Tonbridge TN9 1BL. We will confirm receipt of this by contacting you in writing, normally by e-mail.</li>
          <li>If we have to contact you or give you notice in writing, we will do so by e-mail or by pre-paid post to the address you provide to us in your order.</li>
          <li>Please note that any notice given by you to us, or by us to you, will be deemed received and properly served immediately when posted on our website, 24 hours after an e-mail is sent, or three days after the date of posting of any letter. In proving the service of any notice, it will be sufficient to prove, in the case of a letter, that such letter was properly addressed, stamped and placed in the post and, in the case of an e-mail, that such e-mail was sent to the specified e-mail address of the addressee.</li>
        </ol>
      </li>

      <li class="outer">
        <h3>Other important terms</h3>
        <ol>
          <li>We may transfer our rights and obligations under a Contract to another organisation, but this will not affect your rights or our obligations under these Terms.</li>
          <li>Each of the paragraphs of these Terms operates separately. If any court or relevant authority decides that any of them are unlawful or unenforceable, the remaining paragraphs will remain in full force and effect.</li>
          <li>If we fail to insist that you perform any of your obligations under these Terms, or we do not enforce our rights against you, or if we delay in doing so, that will not mean that we have waived our rights against you and will not mean that you do not have to comply with those obligations. If we do waive a default by you, we will only do so in writing, and that will not mean that we will automatically waive any later default by you.</li>
          <li>Please note that these Terms are governed by English law. This means a Contract for the purchase of Products through our site and any dispute or claim arising out of or in connection with it will be governed by English law. You and we both agree to that the courts of England and Wales will have non-exclusive jurisdiction</li>
        </ol>
      </li>

      <li class="outer">
        <h3>What you are provided with as Partner Organisation</h3>
        <ol>
          <li>Once you become a findmykit lost property service partner you will be provided with a dashboard providing you with the following:
            <ol>
              <li>Secure Log In</li>
              <li>My Organisation dashboard</li>
              <li>Found item code entry panel </li>
              <li>Invitation function allowing you invite members of your organisation to join findmykit for free and purchase our products </li>
              <li>A revenue sharing option </li>
              <li>A history of scanned & collected items that have been found but not collected </li>
              <li>A history of items that have been scanned and returned </li>
              <li>A 'how to manage my lost property service at my organisation' document</li>
              <li>A list of members from your organisation who have joined the findmykit lost property service - these are call partner members</li>
              <li>A partner organisation App which can be downloaded for free from your App Store</li>
            </ol>
          </li>
        </ol>
      </li>

      <li class="outer">
        <h3>How it works</h3>
        <ol>
          <li>When an item with a findmykit smart tag is brought to you - all you need to do is simply scan the smart tag attached to the item using our App.</li>
          <li>After you scan the item, the owner will be notified by text and email that an item of theirs has been found, and they can collect it from your organisation </li>
          <li>When the member comes to collect their item you use the findmykit app to scan the item again and select the Collected option, enter the type of item and select Confirm Collected </li>
          <li>We will confirm the collection with the member and update your scanned & collected history log in your My Organisation Dashboard.</li>
          <li>We now allow a member of the public to scan and return items to your organisation even if they are not a member of your findmykit partner organisation</li>
          <li>This means if a member of findmykit who is part of your lost property service and associated with your organisation loses an item and a member of the public scans the smart tag we will ask them to post or return the item to your organisation</li>
          <li>We kindly ask that you re-scan any items given to you by the public, to notify the owner the item is ready to collect from you.</li>
        </ol>
      </li>
    </ol>

  </div>
</template>

<script>
export default {
  name: "TermsContentOrganisation"
}
</script>

<style scoped>

</style>
